var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HelpFaq"},[_c('Card',{attrs:{"title":'Najczęściej zadawane pytania',"subtitle":'Wybierz pytanie, aby poznać odpowiedź'}},_vm._l((_vm.faqList),function(faq,index){return _c('HelpFaqItem',{key:index,attrs:{"item":faq,"index":index}})}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d717d84","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Help/HelpFaq/index.vue
// module id = 1496
// module chunks = 9